module.exports = __webpack_public_path__ + "img/notLive.501711a6.png";